export default {
  fileType: { type: 'enum', required: true },

  paths: {
    type: 'array',
    maxSize: 1,
    required: true,
  },
};
